import {
  SuccessTitle,
  SuccessDescription,
  SuccessActions,
} from '@remote-com/mushu/src/components/Success';
import { Button } from '@remote-com/norma/core/button';
import { Form as FormikForm } from 'formik';
import {
  lineHeightAsRatio,
  pixelToRem,
  fluidProp,
  whenProp,
} from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { mobileBreakpoint } from '@/src/domains/shared/breakpoints';

export const FormContainer = styled.div`
  display: grid;
  background-color: var(--colors-blank);
  box-shadow: 0px 12px 48px rgba(96, 101, 123, 0.24);
  border-radius: 10px;
  box-sizing: border-box;
  ${fluidProp(['padding'], '24px', '50px')}
`;

export const ModalTitle = styled.h2`
  color: var(--colors-darkBlue);
  ${({ theme }) => theme.typography.titleXXL};

  ${whenProp(
    '$centerText',
    css`
      text-align: center;
    `
  )}

  > * {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const ModalDescription = styled.p`
  color: var(--colors-lynch);
  ${({ theme }) => theme.typography.body};
`;

export const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ListPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
export const Pill = styled.div`
  ${({ theme }) => theme.typography.bodySMMedium};
  color: var(--colors-irisBlue);
  background: var(--colors-selago);
  padding: 5px 12px;
  border-radius: 50px;
`;

export const ListHeading = styled.h3`
  ${({ theme }) => theme.typography.body};
  color: var(--colors-lynch);
  text-transform: uppercase;
  margin: 22px 0;
`;

export const FormError = styled.p`
  display: block;
  color: var(--colors-redPink);
  ${({ theme }) => theme.typography.bodyCaption};
  width: 100%;
  margin-top: 4px;
`;

export const Form = styled(FormikForm)`
  display: grid;
  gap: 12px;
  color: var(--colors-lynch);
  ${({ theme }) => theme.typography.bodySM};
  padding-top: 20px;

  a {
    color: var(--colors-irisBlue);
    text-decoration: none;

    &:visited {
      text-decoration: none;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const CaptchaWrapper = styled.div`
  padding-top: 16px;
  ${mobileBreakpoint(css`
    & > div > div > div {
      width: calc(100vw - 80px) !important;
      overflow: hidden;
    }
  `)}
`;

export const DynamicFormWrapper = styled.div`
  color: var(--colors-lynch);
  ${({ theme }) => theme.typography.bodySM};
  padding-top: 20px;

  ${ModalTitle} {
    padding-bottom: 12px;
  }

  ${CaptchaWrapper} {
    padding-top: unset;
    margin-top: -50px;
    margin-bottom: 50px;
  }
`;

export const SubmitButtonWrapper = styled.div`
  width: max-content;
  margin: 0 auto;
  text-align: center;
`;

export const SubmitButton = styled(Button).attrs({
  shadow: true,
  type: 'submit',
})`
  width: max-content;
  margin: 20px 0;

  &:disabled {
    background-color: var(--colors-spindle);
    cursor: not-allowed;
  }
`;

export const SuccessButton = styled(Button).attrs({
  shadow: true,
})`
  width: max-content;
  margin: 20px 0;

  &:disabled {
    background-color: var(--colors-spindle);
    cursor: not-allowed;
  }
`;

export const SubsribeSuccessContainer = styled.div`
  display: grid;
  place-items: center;
  text-align: center;
  font-size: ${pixelToRem('18px')};
  line-height: ${lineHeightAsRatio('26px', '18px')};
  color: var(--colors-bayoux);

  ${SuccessTitle} {
    color: var(--colors-darkBlue);
  }

  ${SuccessDescription} {
    max-width: initial;
  }

  ${SuccessDescription} + ${SuccessActions} {
    padding-top: 40px;
  }

  ${SuccessActions} + ${SuccessDescription} {
    padding-top: 40px;
  }

  ${SuccessActions} {
    margin-bottom: 0;
  }

  a {
    font-size: ${pixelToRem('20px')};
    line-height: ${lineHeightAsRatio('28px', '20px')};
  }
`;
